//stolen from https://github.com/slab/quill/issues/4535#issuecomment-2874963898
import Quill from 'quill';

export function installQuillNbspFix() {
  // Get the original method that *every* Quill instance inherits
  const original = (Quill as any).prototype.getSemanticHTML;

  // multi installation prevention
  if (original.__nbspFixInstalled) {
    return;
  }
  
  // ugly patch to fix the issue with &nbsp; in Quill
  (Quill as any).prototype.getSemanticHTML = function (
    this: Quill,              // explicit `this` for TS strict‑mode
  ): string {
    const html = original.call(this, ...arguments);
    return html.replace(/&nbsp;|\u00A0/g, ' ');
  };

  (Quill as any).prototype.getSemanticHTML.__nbspFixInstalled = true;
}